import { FiMoreHorizontal, FiEdit, FiTrash2 } from "react-icons/fi";
import { useState, useRef, useEffect } from "react";
import '../css/ActionsDropDown.css';
import { DeleteConfirmationDialog } from "./DeleteConfirmationDialog";
import { useTranslation } from "react-i18next";

export const ActionsDropdown = ({ rowData, onEdit, onDelete }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const dropdownRef = useRef(null);
  const {t} = useTranslation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDeleteConfirm = () => {
    onDelete(rowData);
    setShowDeleteConfirm(false);
    setIsOpen(false);
  };

const defaultActions = [
    // English Comment: Only add edit if onEdit is a truthy value
    ...(onEdit ? [{ 
      label: t("actions.edit"), 
      icon: <FiEdit size={16} className="mr-2" />, 
      onClick: (row) => {
        onEdit(row);
        setIsOpen(false);
      }
    }] : []),
    
    // English Comment: Only add delete if onDelete is a truthy value
    ...(onDelete ? [{ 
      label: t("actions.delete"), 
      icon: <FiTrash2 size={16} className="mr-2" />, 
      onClick: () => {
        setShowDeleteConfirm(true);
      }
    }] : [])
  ];

  const allActions = [
    ...defaultActions,
    ...(rowData.actions || [])
  ];

  return (
    <div className="position-relative" ref={dropdownRef}>
      <button 
        className="btn btn-sm bg-transparent border-0 p-0"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
      >
        <FiMoreHorizontal className="fs-5 purple-text-color"/>
      </button>
      
      {isOpen && (
        <div className="dropdown-menu show position-absolute">
          {allActions.map((action, index) => (
            <button
              key={index}
              className="dropdown-item"
              onClick={(e) => {
                e.stopPropagation();
                action.onClick(rowData);
              }}
            >
              {action.icon && <span className="action-icon">{action.icon}</span>}
              {action.label}
            </button>
          ))}
        </div>
      )}

      {/* Delete Confirmation Dialog */}
      {showDeleteConfirm && (
        <DeleteConfirmationDialog onDelete={handleDeleteConfirm} onCancel={() => setShowDeleteConfirm(false)}/>
        
      )}
    </div>
  );
};